var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clearfix"},[_c('compFormEdit',{ref:"dataForm",attrs:{"labelWidth":150,"formdata":_vm.getBase},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }